import { Component, OnInit } from '@angular/core';
import { Personen } from '../../../_shared/interfaces';
import { AlertService, IAlertType, PersonsStoreService } from '../../../_shared/services';
import { ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule } from '@clr/angular';
import { RouterLink } from "@angular/router";
import { NgIf } from "@angular/common";
import { ClarityIcons, twoWayArrowsIcon } from "@cds/core/icon";

@Component({
  selector: 'app-persons',
  standalone: true,
  imports: [
    RouterLink,
    NgIf,
    ClrIconModule,
    ClrDatagridModule
  ],
  templateUrl: './persons.component.html',
  styleUrl: './persons.component.sass'
})
export class PersonsComponent implements OnInit {
  persons: Personen[] = [];
  companyID: number= 0;
  descSort = ClrDatagridSortOrder.ASC;
  loading: boolean= true;

  constructor(
    private css: PersonsStoreService,
    public alertDispatcher: AlertService
  ) {
    ClarityIcons.addIcons(twoWayArrowsIcon);
  }

  ngOnInit() {
    this.loadList();
  }

  loadList() {
    this.css.getAllPersonen().subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.alertDispatcher.show({
            message: ' Keine Personen gefunden! ',
            clrAlertType: IAlertType.WARNING
          }, 2000);
        }
        this.persons = data.object;
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {
        return
      }
    });
  }

}
